module.exports = __webpack_public_path__ + "static/media/circle-view-off.b9e186f4.svg";